import { TiktokRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = {
  [TiktokRecommendationKey.TIKTOK_2FA]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TiktokRecommendationKey.TIKTOK_2FA,
      ),
    ],
  },
  [TiktokRecommendationKey.TIKTOK_ACTIVITY_STATUS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TiktokRecommendationKey.TIKTOK_ACTIVITY_STATUS,
      ),
    ],
  },
  [TiktokRecommendationKey.TIKTOK_AD_DATA]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TiktokRecommendationKey.TIKTOK_AD_DATA,
      ),
    ],
  },
  [TiktokRecommendationKey.TIKTOK_COMMENTS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TiktokRecommendationKey.TIKTOK_COMMENTS,
      ),
    ],
  },
  [TiktokRecommendationKey.TIKTOK_CONTENT_INTERACTIONS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TiktokRecommendationKey.TIKTOK_CONTENT_INTERACTIONS,
      ),
    ],
  },
  [TiktokRecommendationKey.TIKTOK_DISCOVERABILITY]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TiktokRecommendationKey.TIKTOK_DISCOVERABILITY,
      ),
    ],
  },
  [TiktokRecommendationKey.TIKTOK_FAMILY_PAIRING]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TiktokRecommendationKey.TIKTOK_FAMILY_PAIRING,
      ),
    ],
  },
  [TiktokRecommendationKey.TIKTOK_LIKED_VIDEOS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TiktokRecommendationKey.TIKTOK_LIKED_VIDEOS,
      ),
    ],
  },
  [TiktokRecommendationKey.TIKTOK_SCREEN_TIME]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TiktokRecommendationKey.TIKTOK_SCREEN_TIME,
      ),
    ],
  },
  [TiktokRecommendationKey.TIKTOK_SUGGEST_ACCOUNT_TO_SYNCED_CONTACTS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TiktokRecommendationKey.TIKTOK_SUGGEST_ACCOUNT_TO_SYNCED_CONTACTS,
      ),
    ],
  },
}

export const tiktokRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs: () => [],
  getAdditionalFullGatherStageDefs: () => [],
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: () => true,
}
